import { NoteId, NoteTopicId, Relations } from "@inrev/common";
import { useCreateAdminNote, useUpdateAdminNote } from "@portal/api/note/admin";
import { AutoSaveTextarea } from "@portal/components/ui/AutoSaveTextarea";

// Handles both creating and updating notes
export const AdminNoteEditor = ({
	relation,
	topicId,
	content,
	currentNoteId,
	closeEditor,
	isUpdate = false,
}: {
	relation: Relations.Notes;
	topicId: NoteTopicId;
	content?: string;
	currentNoteId?: NoteId;
	isUpdate?: boolean;
	closeEditor: () => void;
}) => {
	const { createAdminNote } = useCreateAdminNote();
	const { updateAdminNote } = useUpdateAdminNote();

	const handleCreate = (noteContent: string) => {
		if (!relation) return;
		if (!isUpdate) {
			createAdminNote({
				content: noteContent,
				topicId,
				relation,
			});
		}
	};

	const handleUpdate = (noteContent: string) => {
		if (isUpdate && content !== noteContent) {
			if (!relation) return;
			updateAdminNote({
				data: {
					content: noteContent,
				},
				noteId: currentNoteId!,
				topicId,
				relation,
			});
		}
		closeEditor();
	};

	return (
		<AutoSaveTextarea
			content={content}
			isUpdate={isUpdate}
			closeEditor={closeEditor}
			createFn={handleCreate}
			updateFn={handleUpdate}
			placeholder="Enter a note..."
		/>
	);
};
